import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import SparePartsKeys_Header from '../Common/Components/SparePartsKeys_Header.jsx';
import SparePartsKeys_SearchResult from '../Common/Components/SparePartsKeys_SearchResult.jsx';
import SparePartsKeys_Product from '../Common/Components/SparePartsKeys_Product.jsx';
const SparePartsAndManuals = ({ Categories, Translations, ServicePartsModalLink }) => {
    const [selectedProduct, setSelectedProduct] = useState();
    const getQuery = () => {
        const url = new URL(window.location);
        const params = new URLSearchParams(url.search);
        const searchQuery = params.get('q');
        return searchQuery || "";
    }

    const [query, setQuery] = useState(getQuery());

    return (<div className="sparePartsKeys py-10">
        <SparePartsKeys_Header isKeysAndLocks={false} Translations={Translations} Categories={Categories} setQuery={setQuery} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} />
        <div className='sparePartsKeys__contentWrapper'>
            {!selectedProduct && <SparePartsKeys_SearchResult isKeysAndLocks={false} setSelectedProduct={setSelectedProduct} query={query} />}
            {selectedProduct && <SparePartsKeys_Product isKeysAndLocks={false} servicePartsModalLink={ServicePartsModalLink} translations={Translations} product={selectedProduct} />}
        </div>
    </div>);
}
const root = createRoot(document.getElementById('REACT_sparePartsAndManuals'));
root.render(
    <Sentry.ErrorBoundary>
        <SparePartsAndManuals {..._THULEDATA.sparePartsAndManuals} />
    </Sentry.ErrorBoundary>
);